module.exports = __webpack_public_path__ + "media/my_images/top/img01-d8c4e7509fdfb7ae073afcbecab383f4.jpg";